<template>
  <div>
    <div class="upload-wrapper">
      <!-- 自定义上传按钮 -->
      <button class="upload-btn" @click="triggerFileUpload">上传 Excel</button>
      <input type="file" ref="fileInput" @change="handleFileUpload" accept=".xlsx, .xls" style="display: none;" />

      <!-- 显示解析出的adid和requestid -->
      <div v-if="parsedData.length" class="data-display">
        <h3>adid 和 requestid 为:</h3>
        <ul>
          <li v-for="(item, index) in parsedData" :key="index">
            adid: {{ item.adid }} | requestid: {{ item.requestid }}
          </li>
        </ul>
      </div>
    </div>

    <el-form class="login-container" label-position="left" label-width="0px">
      <el-form-item>
        <el-select v-model="values" placeholder="上报类型">
          <el-option v-for="items in level" :key="items.value" :label="items.label" :value="items.value"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="success" @click="submitData">用户上报</el-button>
    </el-form>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      parsedData: [], // 存储从URL中解析出的adid和requestid
      values: '',
      level: [
        { value: 'DIALOGUE_MPA', label: '微信-用户首次消息' },
        { value: 'ADD_WECHAT', label: '微信-添加微信' },
        { value: 'REGISTER', label: '自定义注册' },
        { value: 'SUBMIT', label: '表单提交' },
        { value: 'WEBPAY', label: '网页购买+' },
        { value: 'INEFFECTIVE_LEADS', label: '无效线索' },
        // { value: 'ADD_SCREEN', label: '加桌' }
      ]
    };
  },
  methods: {
    // 触发文件上传
    triggerFileUpload() {
      this.$refs.fileInput.click(); // 触发隐藏的文件上传input
    },

    // 处理文件上传
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // 解析第一个表格
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

        // 从第二行开始解析数据，第一行为表头
        this.parsedData = jsonData.slice(1).map((row) => {
          const url = row[0]; // 假设第一列是URL
          const adid = this.extractParam(url, 'adid');
          const requestid = this.extractParam(url, 'requestid');
          return { adid, requestid };
        });

        // 清除文件上传状态
        this.resetFileInput();
      };

      reader.readAsArrayBuffer(file);
    },

    // 提取URL中的参数
    extractParam(url, param) {
      try {
        const urlObj = new URL(url);
        return urlObj.searchParams.get(param);
      } catch (e) {
        console.error(`无法解析URL: ${url}`);
        return null;
      }
    },

    // 重置文件上传状态
    resetFileInput() {
      this.$refs.fileInput.value = '';
    },

    // 异步递归逐条发送请求
    async submitData() {
      for (let i = 0; i < this.parsedData.length; i++) {
        const { adid, requestid } = this.parsedData[i];

        // 检查提取的adid和requestid是否有效
        if (adid && requestid) {
          // 更新 creativeId 和 requestId
          const payload = {
            creativeId: adid,
            requestId: requestid,
            cvType: this.values
          };

          try {
            await this.sendRequest(payload);
          } catch (error) {
            console.error(`请求失败，adid: ${adid}, requestid: ${requestid}`, error);
          }
        } else {
          console.warn(`跳过无效数据，adid: ${adid}, requestid: ${requestid}`);
        }
      }
    },

    // 用户上报请求
    async sendRequest({ creativeId, requestId, cvType }) {
      const time = Date.now().toString();
      const nonce2 = Math.floor(Math.random() * 100000000000).toString();
      const token = '050882462da615ea58cd1338327c01ab9c572e42e6b97c3df14f9a335547de5f';
      const adid = '96f898521c3c57659e00';

      const url = `api/openapi/v1/advertiser/behavior/upload?access_token=${token}&timestamp=${time}&nonce=${nonce2}&advertiser_id=${adid}`;

      const payload = {
        srcId: 'ds-202308150901',
        pageUrl: 'https://www.baidu.com',
        srcType: 'Web',
        dataList: {
          cvTime: time,
          requestId,
          cvType,
          creativeId
        }
      };

      return this.$axios.post(url, payload).then((resp) => {
        if (resp.data.code !== 0) {
          this.$notify.error({
            title: '错误',
            message: `上报失败: adid ${creativeId}`
          });
          throw new Error('请求失败');
        } else {
          this.$notify({
            title: '成功',
            message: `上报成功: adid ${creativeId}`,
            type: 'success'
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

.upload-btn {
  background-color: #409EFF;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.upload-btn:hover {
  background-color: #66b1ff;
}

.data-display {
  margin-top: 20px;
  text-align: center;
}

.data-display h3 {
  font-weight: bold;
  color: #333;
}

.data-display ul {
  list-style-type: none;
  padding: 0;
}

.data-display li {
  padding: 5px 0;
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/vivoplsb.vue